import classNames from 'classnames';
import PropTypes from 'prop-types';

const DropdownItem = ({
  item,
  index,
  handleSelect,
  isDrugIndex,
  isSuggestion = false,
  highlightText,
  keyword,
  resultStyle,
}) => {
  const text = isSuggestion ? item.suggestion : item.searchText;
  const typeLabel = isSuggestion ? item.type : null;

  return (
    <div
      role='link'
      key={index}
      className={
        resultStyle[
          isSuggestion ? 'dropdown-item' : 'dropdown-recent-saved-item'
        ]
      }
      onClick={() => handleSelect(item)}
      onKeyDown={(e) => e.key === 'Enter' && handleSelect(item)}
      tabIndex={0}
      onMouseDown={(e) => e.preventDefault()}
      data-testid='search-suggestions'
    >
      {typeLabel && <div className='light text-xs capitalize'>{typeLabel}</div>}
      {isDrugIndex ? (
        highlightText(text, keyword)
      ) : (
        <span
          className={classNames('medium text-sm', resultStyle.description)}
          dangerouslySetInnerHTML={{ __html: text }}
        />
      )}
    </div>
  );
};

DropdownItem.propTypes = {
  item: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  handleSelect: PropTypes.func.isRequired,
  isDrugIndex: PropTypes.bool,
  isSuggestion: PropTypes.bool,
  highlightText: PropTypes.func.isRequired,
  keyword: PropTypes.string,
  resultStyle: PropTypes.object.isRequired,
};

export default DropdownItem;
